import { Package } from "lucide-react";

export default function ImagePlaceholder() {
  return (
    <div className="rounded-sm flex justify-center items-center text-(--primary)">
      <Package style={{ width: "100%", height: "100%" }} />
    </div>
  );
}
